import React from "react";

interface OwnProps {
  title: string;
}

type Props = OwnProps;

export default class DocumentTitleProvider extends React.PureComponent<Props> {
  public setTitle(title: string) {
    document.title = title;
  }

  public componentDidMount() {
    this.setTitle(this.props.title);
  }

  public componentDidUpdate(prevProps: Props) {
    if (prevProps.title !== this.props.title) {
      this.setTitle(this.props.title);
    }
  }

  public render() {
    return null;
  }
}
